import { Link } from "react-router-dom";
import { Pencil, Eye, LayoutDashboard, HelpCircle } from "lucide-react";
import { useCmsEdit } from "./CmsEditContext";

export function CmsEditBar() {
  const { isEditor, editMode, setEditMode, pageSlug } = useCmsEdit();
  if (!isEditor) return null;

  return (
    <div className="fixed right-0 top-1/2 -translate-y-1/2 z-[100] flex flex-col items-center gap-3 bg-card border border-r-0 rounded-l-xl shadow-xl px-2 py-4 w-[72px]">
      <span className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground text-center leading-tight">
        CMS
      </span>

      <div className="w-8 h-px bg-border" />

      <button
        onClick={() => setEditMode(false)}
        disabled={!pageSlug}
        className={`flex flex-col items-center gap-1 rounded-lg px-2 py-2 text-[10px] font-medium transition-colors w-full ${
          !editMode
            ? "bg-primary text-primary-foreground"
            : "hover:bg-muted/70"
        } disabled:opacity-40 disabled:cursor-not-allowed`}
        title={pageSlug ? undefined : "Diese Seite ist noch nicht editierbar"}
      >
        <Eye className="h-5 w-5" />
        <span className="leading-none">Vorschau</span>
      </button>

      <button
        onClick={() => setEditMode(true)}
        disabled={!pageSlug}
        className={`flex flex-col items-center gap-1 rounded-lg px-2 py-2 text-[10px] font-medium transition-colors w-full ${
          editMode
            ? "bg-primary text-primary-foreground"
            : "hover:bg-muted/70"
        } disabled:opacity-40 disabled:cursor-not-allowed`}
        title={pageSlug ? undefined : "Diese Seite ist noch nicht editierbar"}
      >
        <Pencil className="h-5 w-5" />
        <span className="leading-none">Bearbeiten</span>
      </button>

      <Link
        to="/cms-backend/dashboard"
        className="flex flex-col items-center gap-1 rounded-lg px-2 py-2 text-[10px] font-medium hover:bg-muted/70 transition-colors w-full"
      >
        <LayoutDashboard className="h-5 w-5" />
        <span className="leading-none">Backend</span>
      </Link>

      <div className="w-8 h-px bg-border" />

      <a
        href="mailto:support@huberwebmedia.at?subject=Ich%20brauche%20Hilfe%20beim%20Warten%20meiner%20Website%3A%20https%3A%2F%2Flerch-suites.at"
        target="_blank"
        rel="noopener noreferrer"
        className="flex flex-col items-center gap-1 rounded-lg px-2 py-2 text-[10px] font-medium hover:bg-[#6C184F]/10 text-[#6C184F] transition-colors w-full"
        title="Support kontaktieren"
      >
        <HelpCircle className="h-5 w-5" />
        <span className="leading-none">Support</span>
      </a>
    </div>
  );
}
